import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class AudioProps {
  @Inlet(Accepts.Audio) public audio?: Types["Audio"];
}

export const AudioDefinition = defineElement("audio", AudioProps, {
  versionRequired: "0.8.0",
});
